/**
 *
 *
 *
 */
import { onLoad } from "@otto-ec/global-resources/dom";
import { adoptedStyleSheetsSupport } from "@otto-ec/otto-components-utils/utils/canIUse";
import { canUseHtmlPopoverApi } from "../../../common/utils/canUseHtmlPopoverApi.ts";

onLoad.subscribe(async () => {
  if (
    !adoptedStyleSheetsSupport ||
    !canUseHtmlPopoverApi ||
    !CSS.supports("anchor-name: --a") ||
    !CSS.supports("position-anchor: --a") ||
    !CSS.supports("position-area: top")
  )
    return;

  const { init } = await import("./TooltipV2.ts");
  init();
});
